import {BaseRouteMetaDataModel} from "../../../infrastructure/models/route/base-route.meta-data.model";
import {WebsiteModuleState} from "../../../apps/website/models/website-module.state";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DashboardLinkParams} from "../../dashboard-container/models/dashboard-container-link-params";
import {DASHBOARD} from "../../dashboard-container/dashboard-container.consts";
import {AllScoresLinkParams} from "./all-scores-container-link-params";
import {SchemaManager} from "../../../core/managers/schema-manager";
import {AppTerms} from "../../../core/app/app-terms";
import {FaqPageSchemaModel} from "../../../core/models/schema/faq-page-schema-model";
import {BaseSchemaModel} from "../../../core/models/schema/base-schema-model";
import {MetadataManager} from "../../../core/managers/metadata.manager";
import {AllScoresRoutePageTitleModel} from "./page-metadata/all-scores-route.page-title-model";
import {AllScoresRoutePageDescriptionModel} from "./page-metadata/all-scores-route.page-description-model";

export class AllScoresRouteMetaDataModel extends BaseRouteMetaDataModel {
  get websiteModel(): WebsiteModuleState {
    return this.resolve(WebsiteModuleState);
  }

  get navigationManager(): NavigationManager {
    return this.resolve(NavigationManager);
  }

  get datetimeUtils(): DatetimeUtils {
    return this.resolve(DatetimeUtils);
  }

  get schemaManager(): SchemaManager {
    return this.resolve(SchemaManager);
  }

  get metadataManager(): MetadataManager {
    return this.resolve(MetadataManager);
  }

  get dataSchemaFAQ(): FaqPageSchemaModel {
    return this.websiteModel.appState.appFaqDisplayModel?.hasElements && this.schemaManager.createFAQPage(this.websiteModel.appState.appFaqDisplayModel?.elements);
  }

  get terms(): AppTerms {
    return this.websiteModel?.terms;
  }

  get sportType() {
    return this.websiteModel.appState.context.sportType
  }

  get isLive(): Boolean {
    const params: DashboardLinkParams = this.navigationManager.currentLinkModel.params;
    const isLive = params.filter === DASHBOARD.FILTERS.live;

    return isLive;
  }

  get dataSchema(): Array<BaseSchemaModel> {
    const params = new AllScoresLinkParams(this.navigationManager.currentLinkModel.params.sportName, this.navigationManager.currentLinkModel.params.filter);
    let dataSchema: Array<BaseSchemaModel> = [];

    if (!params.sportName && !params.filter) {
      dataSchema.push(this.schemaManager.createOrganization());
    }
    dataSchema.push(this.schemaManager.createWebsite());

    return dataSchema;
  }

  get date(): Date {
    const params = new AllScoresLinkParams(this.navigationManager.currentLinkModel.params.sportName, this.navigationManager.currentLinkModel.params.filter);
    const isDate: Boolean = this.websiteModel.currentLinkModel.hashParams.date !== undefined;

    let date: Date = new Date();

    if (isDate) {
      date = this.datetimeUtils.fromString(this.websiteModel.currentLinkModel.hashParams.date , 'yyyy-MM-dd');
    } else {
      date = params.filter
    }

    return date;
  }

  get isNoIndex(): Boolean {
    const date = this.websiteModel.currentLinkModel.hashParams.date;
    const isNoIndex = !!date;

    return isNoIndex;
  }

  get pageTitle(): String {
    const pageTitleModel: AllScoresRoutePageTitleModel = new AllScoresRoutePageTitleModel(
      this.metadataManager?.titleSection, this.terms, this.datetimeUtils, this.date, this.sportType, this.isLive)

    return pageTitleModel.title;
  }

  get description(): String {
    const pageDescriptionModel: AllScoresRoutePageDescriptionModel = new AllScoresRoutePageDescriptionModel(
      this.metadataManager?.descriptionSection, this.terms, this.datetimeUtils, this.date, this.sportType, this.isLive)

    return pageDescriptionModel.description;
  }
}
